import createClient from 'openapi-fetch';
import * as qs from 'qs';

import { IS_STRAPI_DEV, DEV_HOST } from '@monoimin/constants';

import Logger from 'libs/utils/src/lib/debug/Logger';
import { isProductionEnv } from 'libs/utils/src/lib/envUtils';

import type { paths } from '@monoimin/sb-types';

const BASE_URL = IS_STRAPI_DEV
  ? `${DEV_HOST}/api`
  : 'https://wonderful-dogs-8ceb8899a2.strapiapp.com/api';

const isProduction = isProductionEnv();

const logger = new Logger('Strapi API', 'server', !isProduction);

const strapiFetch: typeof fetch = async (input, options) => {
  const startTime = performance.now();
  let response: Response;

  try {
    response = await fetch(input, options);
  } catch (error) {
    logger.error('Network error during fetch', {
      error,
      request: {
        input,
        options,
      },
    });
    throw error;
  }

  const endTime = performance.now();
  const duration = endTime - startTime;

  const responseHeaders = Object.fromEntries(response.headers.entries());
  // Удаляем куки из логов потому что они могут содержать персональные данные
  delete responseHeaders['set-cookie'];

  if (!response.ok) {
    const errorBody = await response.text();
    logger.error('API Request failed', {
      request: {
        url: typeof input === 'string' ? input : (input as Request).url,
        headers: options?.headers,
        body: options?.body,
      },
      response: {
        status: response.status,
        statusText: response.statusText,
        headers: responseHeaders,
        body: errorBody,
      },
      duration: `${duration.toFixed(2)}ms`,
    });
    throw new Error(`Request failed with status ${response.status}`);
  }
  // else if (!IS_DEV) {
  //   logger.info('API Request completed', {
  //     request: {
  //       url: typeof input === 'string' ? input : (input as Request).url,
  //       headers: options?.headers,
  //       body: options?.body,
  //     },
  //     response: {
  //       status: response.status,
  //       statusText: response.statusText,
  //       headers: responseHeaders,
  //     },
  //     duration: `${duration.toFixed(2)}ms`,
  //   });
  // }

  return response;
};

export const { GET } = createClient<paths>({
  baseUrl: BASE_URL,
  querySerializer: (q: object) => qs.stringify(q, { encodeValuesOnly: true }),
  cache: IS_STRAPI_DEV ? 'no-store' : 'force-cache',
  fetch: strapiFetch,
});
